import React from 'react';
import styled from '@emotion/styled';
import BgImg from 'ui/images/top/topOffer_bg.png';
import BgImg02 from 'ui/images/top/topOffer_img02@2x.png';
import BgImg01 from 'ui/images/top/topOffer_img01@2x.png';
import OfferImg01 from 'ui/images/top/topOffer_img01@2x.png';
import { mqMin } from 'utils/responsive';
import { Only } from 'ui/components/elements/Only/Only';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
    position: relative;
    border-top: solid 2px var(--dark-blue);
    border-bottom: solid 2px var(--dark-blue);
    background-image: url(${BgImg}), url(${BgImg02}), url(${BgImg01});
    background-repeat: repeat, no-repeat, no-repeat;
    background-size: 10px 10px, auto 177px, auto 177px;
    background-position: left -20px bottom, right -18px bottom;
    background-color: var(--light-orange);
    color: #fff;
    text-align: center;
    padding: 47px 0;

    ${mqMin('NARROW')} {
        position: relative;
        width: 900px;
        border: 0;
        background: none;
        padding: 0;
        margin: 0 auto 0 auto;
    }
`;

const LeftContainer = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        position: absolute;
        bottom: 0;
        left: -65px;
        display: block;
        width: 172px;
    }
`;

const RightContainer = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        position: absolute;
        bottom: 0;
        right: -55px;
        display: block;
        width: 172px;
    }
`;

const OfferMainContainer = styled.div`
    ${mqMin('NARROW')} {
        width: 100%;
        border: solid 2px var(--dark-blue);
        border-radius: 12px;
        background-image: url(${BgImg});
        background-repeat: repeat;
        background-size: 10px 10px;
        background-color: var(--light-orange);
        color: #fff;
        text-align: center;
        padding: 54px 0;
    }
`;

const H2 = styled.h2`
    font-size: 1.311rem;
    line-height: 1.8rem;
    letter-spacing: 0.1em;
    margin-bottom: 10px;

    ${mqMin('NARROW')} {
        font-size: 1.5rem;
    }
`;

const BottomContainer = styled.div`
    text-align: center;
    padding: 42px 0 62px 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    width: fit-content;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        gap: 1.5rem;
        flex-direction: row;
        text-align: center;
        padding: 57px 0 78px 0;
    }
`;

const ButtonBlue = styled.a`
    display: block;
    background-color: var(--blue);
    border-radius: 8px;
    border: solid 1px #fff;
    color: #fff;
    text-align: center;
    text-decoration: none;
    padding: 16px 20px;
    margin: 0 auto 0 auto;
    transition: all 0.3s;
    width: 9.18rem;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        color: var(--blue);
        background: var(--white);
    }

    ${mqMin('SP')} {
        width: 18.57rem;
    }

    ${mqMin('NARROW')} {
        width: 16.5rem;
        font-size: 0.9rem;
    }
`;

const ButtonDarkBlue = styled(ButtonBlue)`
    background-color: var(--dark-blue);
    border: solid 1px var(--dark-blue);
    width: 18.57rem;

    &:hover {
        background: var(--white);
        color: var(--dark-blue);
    }

    ${mqMin('NARROW')} {
        font-size: 0.9rem;
    }
`;

const ButtonWhite = styled(ButtonBlue)`
    width: 18.57rem;
    background-color: var(--white);
    border: solid 1px var(--dark-blue);
    color: var(--dark-blue);

    &:hover {
        background: var(--dark-blue);
        color: var(--white);
    }
`;

export const Offer: React.FC = () => {
    const navigate = useNavigate();

    const goToRegister = () => {
        navigate('/buyer/send-registration-mail/');
    };
    const goToAgentPage = () => {
        navigate('/agent/');
    };
    const goToContactPage = () => {
        window.open('/contact/', '_blank');
    };
    return (
        <>
            <section className="fadein fadein_y">
                <Container>
                    <LeftContainer>
                        <img src={OfferImg01} alt="" />
                    </LeftContainer>
                    <OfferMainContainer>
                        <H2>
                            希望条件を投稿して、
                            <Only sp>
                                <br />
                            </Only>
                            仲介会社から
                            <Only sp>
                                <br />
                            </Only>
                            オファーを受けよう
                        </H2>
                        <br />
                        <ButtonBlue onClick={goToRegister}>新規登録はこちら</ButtonBlue>
                    </OfferMainContainer>
                    <RightContainer>
                        <img src={BgImg02} alt="" />
                    </RightContainer>
                </Container>
                <BottomContainer>
                    <ButtonDarkBlue onClick={goToAgentPage}>仲介会社登録</ButtonDarkBlue>
                    <ButtonWhite onClick={goToContactPage}>お問い合わせ</ButtonWhite>
                </BottomContainer>
            </section>
        </>
    );
};
